import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ThemeProps } from 'styled-components';
import type { SystemColorType, ThemeType } from '../../../util/types';
import styled, { css } from 'styled-components';
import { getPolishedColors } from '../../../util/styled';
import { LessonStatusEnum as Outcomes } from '@whizz/api-model';

const statuses: Record<Exclude<Outcomes, Outcomes.EMPTY>, {
  label: string,
  color: SystemColorType
}> = {
  'Incomplete': {
    label: 'INCOMPLETE',
    color: 'warning',
  },
  'Passed': {
    label: 'PASSED',
    color: 'success',
  },
  'Regressed': {
    label: 'FAILED',
    color: 'error',
  },
  'Static': {
    label: 'STATIC',
    color: 'warning',
  },
  'Jumped': {
    label: 'JUMPED',
    color: 'success',
  },
};

const getColors = (props: ThemeProps<ThemeType> & { $color: SystemColorType }) => {
  const colors = getPolishedColors(props);
  return css`
    background: ${colors.main.color};
    color: ${colors.main.readable};
  `;
};

const OutcomeStyled = styled('div')<{
  $color: SystemColorType
}>`
  ${(props) => getColors(props)}
`;

const Outcome = ({ status }: { status: Outcomes }): JSX.Element => {
  if (Outcomes.EMPTY === status) return (
    <div className='w-20'>&nbsp;</div>
  );

  const { translate } = useI18n();
  const { color, label } = statuses[status];
  return (
    <div className={'bg-white rounded'}>
      <OutcomeStyled $color={color} className={'rounded py-0.5 px-2 lg:py-3 lg:px-6 w-full text-center font-bold'}>
        {translate(`pages.HISTORY.OUTCOMES.${label}`)}
      </OutcomeStyled>
    </div>
  );
};

const TopicAndLearningObjective = ({ topic, learning_objective }: { topic: string, learning_objective: string }): JSX.Element => (
  <div>
    <div className={'font-bold'}>{topic}</div>
    <div>{learning_objective}</div>
  </div>
);

export { Outcome, TopicAndLearningObjective };
